document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.hd-usp-bar').forEach(bar => {

    const track = bar.querySelector('.hd-usp-bar__track');

    if (!track) return;

    // Nur auf Mobile
    if (window.innerWidth > 990) return;

    const cards = [...track.children];

    // Erste Karten duplizieren
    cards.forEach(card => {
      track.appendChild(card.cloneNode(true));
    });

    let cardWidth = cards[0].offsetWidth + 14;

    track.addEventListener('scroll', () => {

      const maxScroll = cardWidth * cards.length;

      if (track.scrollLeft >= maxScroll) {

        track.scrollLeft = 0;

      }

    });

  });

});